<div class="modal-container">

    <!-- Header -->
    <div class="modal-header">
        Solicitud
    </div>

    <!-- LOADING -->
    <div *ngIf="data.loading" class="loading-container">
        <mat-spinner diameter="50"></mat-spinner>
        <div class="loading-text">Cargando bitácora...</div>
    </div>

    <div *ngIf="!data.loading && data.sinDatos" class="no-data-container">
        <span class="message-span">
            No hay información de bitácora para esta solicitud.
        </span>
    </div>

    <!-- CONTENIDO -->
    <ng-container *ngIf="!data.loading">

        <!-- Info solicitud -->
        <div class="modal-info">
            <div>
                <strong>Fecha de Radicación:</strong> {{ data.fechaRadicacion | date:'dd-MM-yyyy HH:mm' }}
            </div>
            <div class="right">
                <strong>Número radicado:</strong> {{ data.numeroSolicitud }}
            </div>
        </div>

        <!-- Tabla -->
        <div class="table-container">
            <table class="bitacora-table">
                <thead>
                    <tr>
                        <th>Usuario</th>
                        <th>Tipo de gestión</th>
                        <th>Fecha de gestión</th>
                        <th>Lista de órdenes</th>
                        <th>Observaciones</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let g of pagedGestiones">
                        <td>{{ g.USUARIO }}</td>
                        <td>{{ g.TIPO_GESTION }}</td>
                        <td>{{ g.FECHA_GESTION | date:'dd-MM-yyyy HH:mm' }}</td>
                        <td>{{ g.LISTA_ORDENES || '-' }}</td>
                        <td class="obs">{{ g.OBSERVACIONES }}</td>
                    </tr>
                </tbody>
            </table>
            <mat-paginator [length]="data.gestiones?.length || 0" [pageSize]="5" [pageSizeOptions]="[5]"
                (page)="onPageChange($event)">
            </mat-paginator>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
            <button mat-raised-button color="primary" (click)="cerrar()">
                Aceptar
            </button>
        </div>

    </ng-container>

</div>